/* External Imports */
import { AddIcon, MinusIcon } from '@chakra-ui/icons';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  chakra,
} from '@chakra-ui/react';
import parser from 'html-react-parser';

/* Internal Imports */
/* Services */

/**
 * Renders the Faq content component with plus & minus icon
 *
 * @param {object} sectionContent - Data for section
 * @returns {ReactElement} Faq content component
 */

const FaqPlusMinus = ({ section, region, lang }) => {
  const moduledata = section.sectionContent;
  return (
    <Box
      as="div"
      width={{ base: '95%', sm: '95%', md: '730px', lg: '730px' }}
      m={{
        base: '0 auto 30px auto',
        sm: '0 auto 30px auto',
        md: '0 auto 30px auto',
        lg: '0 auto 30px auto',
      }}
      fontFamily="FedraSansStd-book, sans-serif"
    >
      {moduledata?.map((el, i) => {
        return (
          <Accordion
            allowMultiple
            outline="0"
            fontFamily="FedraSansStd-book, sans-serif"
            m="0px auto"
            width={{ base: '100%', md: '100%', lg: '100%' }}
            borderTop="none"
            key={i}
          >
            <AccordionItem
              borderBottom={moduledata?.length - 1 == i ? '0px' : '1px'}
              borderBottomColor="gray.400"
              borderTop="none"
            >
              <AccordionButton
                borderRadius="3px"
                mb="2px"
                fontFamily="FedraSansStd-book, sans-serif"
                fontWeight="bold"
                fontSize={{ base: '16px', sm: '16px', md: '18px', lg: '18px' }}
                pt="4"
                pb="4"
                color="#000000"
                _hover={{ bgColor: '#DED5C3', color: '#28231E' }}
                _focus={{ shadow: 'transparent' }}
              >
                <chakra.div flex="1" textAlign="left">
                  {el.title[0]?.faqTitle}
                </chakra.div>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel pb={1}>
                {el.faqs?.map(elchild => {
                  return (
                    <AccordionItem
                      borderBottom="none"
                      borderTop="none"
                      lineHeight="1.61"
                      className="faq_answer"
                    >
                      {({ isExpanded }) => (
                        <>
                          <AccordionButton
                            p="0.8rem 0 0.8rem 0"
                            fontSize="14px"
                            fontFamily="FedraSansStd-book, sans-serif"
                            lineHeight="22px"
                            borderTop="none"
                            colro="#000000"
                            _hover={{ background: 'none' }}
                            _focus={{ shadow: 'transparent' }}
                          >
                            <chakra.div
                              flex="1"
                              textAlign="left"
                              fontWeight="600"
                            >
                              {elchild?.question}
                            </chakra.div>
                            {isExpanded ? (
                              <MinusIcon fontSize="12px" color="#CF4520" />
                            ) : (
                              <AddIcon fontSize="12px" color="#CF4520" />
                            )}
                          </AccordionButton>
                          <AccordionPanel
                            pb={4}
                            fontFamily="FedraSansStd-book, sans-serif"
                            fontSize="14px"
                            lineHeight="22px"
                            color="#7e7e7e"
                            pl="0"
                          >
                            {parser(elchild?.answer)}
                          </AccordionPanel>
                        </>
                      )}
                    </AccordionItem>
                  );
                })}
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        );
      })}
      <style global jsx>
        {`
          .faq_answer p span {
            font-family: FedraSansStd-book, sans-serif !important;
            font-size: 14px !important;
            line-height: 22px !important;
          }
        `}
      </style>
    </Box>
  );
};
export default FaqPlusMinus;
